// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"bJ-z","carousel":"cJ-z"};